module.exports = __webpack_public_path__ + "img/new_img.a993ddc3.png";